export var FAILED_QUIZ = "ask_teacher_about_failed_quiz"
export var OVERALL_INTENTION = "ask_teacher_about_intention"
export var IMPROVE_QUIZ = "improve_scoring_quiz_general"
export var QUIZ_ACCURACY = "quiz_score_accuracy_confidence"
export var READ_BOOK = "did_student_read_book"
export var SCORING_QUIZ_WRITTEN_RESPONSE = "improve_scoring_quiz_written_responses"
export var DASHBOARD_HELPFULNESS = "improve_helpfulness_of_dashboard"
export var QUIZ_FLAG = "quiz_flag_helpfulness"
export var IMPROVE_AUTOGRADER = "improve_autograder_and_rubric"


export var LAYOUTS = {
  EMBEDED_CONTENT: 'embeded_content',
  SIDEBAR_SURVEY: 'sidebar_survey'
}

export var CONFIG = {
  [FAILED_QUIZ]: {
    description: null,
    layout: LAYOUTS.EMBEDED_CONTENT,
    trigger:
    {
      paths: ["data", 'quizzes'],
      // what we are looking for
      class: ".failDisplay",
      exclude_classes: ['.neutralDisplay']
    },
    location:
    {
      // parent that should hold our new div
      parent: ".quizDisplay",
      // where to insert our div
      anchor: ".topRow",
    },
    style:
    {
      class: 'contentSurvey',
      circle_animation: true
    },
    include_free_response: false,
    select_multiple: false
  },

  [QUIZ_FLAG]: {
    description: null,
    layout: LAYOUTS.EMBEDED_CONTENT,
    trigger:
    {
      paths: ["data", 'quizzes'],
      // what we are looking for
      class: ".answerDetailsFlag",
      exclude_classes: []
    },
    location:
    {
      // parent that should hold our new div
      parent: ".singleQuizView",
      // where to insert our div
      anchor: ".topRow",
    },
    style:
    {
      class: 'contentSurvey twoRows',
      circle_animation: false
    },
    include_free_response: false,
    select_multiple: false
  },

  [DASHBOARD_HELPFULNESS]: {
    description: "pick one answer",
    layout: LAYOUTS.SIDEBAR_SURVEY,
    trigger:
    {
      paths: ["home"],
      // what we are looking for
      class: ".widgetContainer",
      exclude_classes: [],
    },
    location:
    {
      // parent that should hold our new div
      parent: "#pageContent",
      // where to insert our div
      anchor: "#teacherHomePage",
    },
    style:
    {
      class: 'sidebarSurvey',
    },
    include_free_response: true,
    select_multiple: true
  },

  [OVERALL_INTENTION]: {
    description: "pick one answer",
    layout: LAYOUTS.SIDEBAR_SURVEY,
    trigger:
    {
      paths: ["data"],
      // what we are looking for
      class: ".dataPage",
      exclude_classes: []
    },
    location:
    {
      // parent that should hold our new div
      parent: "#pageContent",
      // where to insert our div
      anchor: ".dataPage",
    },
    style:
    {
      class: 'sidebarSurvey',
    },
    include_free_response: true,
    select_multiple: false
  },

  [IMPROVE_QUIZ]: {
    description: null,
    layout: LAYOUTS.SIDEBAR_SURVEY,
    trigger:
    {
      paths: ["data", "quizzes"],
      // what we are looking for
      class: ".editControls",
      exclude_classes: []
    },
    location:
    {
      // parent that should hold our new div
      parent: "#pageContent",
      // where to insert our div
      anchor: ".dataPage",
      // if present, survey doesn't move with page scroll
      absolute_anchor: '.controlModeEdit'
    },
    style:
    {
      class: 'sidebarSurvey',
    },
    include_free_response: true,
    select_multiple: true
  },

  [QUIZ_ACCURACY]: {
    description: "pick one answer",
    layout: LAYOUTS.SIDEBAR_SURVEY,
    trigger:
    {
      paths: ["data"],
      // what we are looking for
      class: ".dataPage",
      exclude_classes: []
    },
    location:
    {
      // parent that should hold our new div
      parent: "#pageContent",
      // where to insert our div
      anchor: ".dataPage",
    },
    style:
    {
      class: 'sidebarSurvey',
    },
    include_free_response: false,
    select_multiple: false
  },

  [READ_BOOK]: {
    description: null,
    layout: LAYOUTS.EMBEDED_CONTENT,
    trigger:
    {
      paths: ["data", 'quizzes'],
      // what we are looking for
      class: ".passDisplay",
      exclude_classes: []
    },
    location:
    {
      // parent that should hold our new div
      parent: ".quizDisplay",
      // where to insert our div
      anchor: ".topRow",
    },
    style:
    {
      class: 'contentSurvey twoRows',
      circle_animation: true
    },
    include_free_response: false,
    select_multiple: false
  },

  [SCORING_QUIZ_WRITTEN_RESPONSE]: {
    description: null,
    layout: LAYOUTS.SIDEBAR_SURVEY,
    trigger:
    {
      paths: ["data", "quizzes"],
      // what we are looking for
      class: ".answerScoringDetails",
      exclude_classes: [],
    },
    location:
    {
      // parent that should hold our new div
      parent: "#pageContent",
      // where to insert our div
      anchor: ".dataPage",
      // if present, survey doesn't move with page scroll
      absolute_anchor: '.controlModeAnalysis'
    },
    style:
    {
      class: 'sidebarSurvey',
    },
    include_free_response: true,
    select_multiple: true
  },

  [IMPROVE_AUTOGRADER]: {
    description: null,
    layout: LAYOUTS.EMBEDED_CONTENT,
    trigger:
    {
      paths: ["home"],
      // what we are looking for
      class: ".rubricTableContainer",
      exclude_classes: []
    },
    location:
    {
      // parent that should hold our new div
      parent: ".answerFeedbackContainer",
      // where to insert our div
      anchor: ".rubricTableContainer",
    },
    style:
    {
      class: 'contentSurvey twoRows',
      circle_animation: true
    },
    include_free_response: false,
    select_multiple: false,
    explain_answer: ['No']
  },
}

export var VALID_KEYS = _.keys(CONFIG)

export var PROMPT_SESSION_KEY = 'prompt_id'

export function getDataPacket(newID, prompt) {
  var el = document.getElementById(newID)

  switch (prompt.key) {
    case this.FAILED_QUIZ:
    case this.QUIZ_FLAG:
    case this.READ_BOOK:
      return {
        'quiz_id': $(el).closest('.quizDisplay').attr("data-quiz-id"),
        'evaluation_id': $(el).closest('.quizDisplay').attr("data-evaluation-id")
      }
    case this.IMPROVE_QUIZ:
    case this.SCORING_QUIZ_WRITTEN_RESPONSE:
      return {
        'quiz_id': $(`${prompt.location.absolute_anchor}`).attr("data-quiz-id"),
        'evaluation_id': $(`${prompt.location.absolute_anchor}`).attr("data-evaluation-id")
      }
  }
}


// WEBPACK FOOTER //
// ./modules/lib/survey/SurveyPromptConfig.js